import { FC, useEffect, useState } from 'react'
import { Col, Form, InputGroup, Row } from 'react-bootstrap'
import ResultContainer from '../ResultContainer'
import { useAppSelector } from '../../../../../store/hooks'
import { Language } from '../../../../../features/security/security.slice'
import { EndPointProps } from '../APIManager.d'
import RunButton from '../extras/RunButton'

const PageEndpoint: FC<EndPointProps> = ({ apiKey, version }) => {
    const initData = useAppSelector((state: any) => state.security.initData)

    const [result, setResult] = useState<object>({})
    const [code, setCode] = useState<string>('')
    const [locale, setLocale] = useState<string>('')
    const [apiUrl, setApiUrl] = useState<string>('')

    useEffect(() => {
        setApiUrl(
            `${process.env.REACT_APP_CLIENT_API_ROOT}/${version}/pages/${code}${
                locale ? '?locale=' + locale : ''
            }`
        )
    }, [code, locale, version])

    return (
        <Row>
            <Col xl={12}>
                <InputGroup className="mb-3">
                    <InputGroup.Text className="px-4">GET</InputGroup.Text>
                    <div className="form-control readonly">{apiUrl}</div>
                    <RunButton
                        disabled={!code}
                        apiUrl={apiUrl}
                        apiKey={apiKey}
                        setResult={setResult}
                    />
                </InputGroup>
            </Col>
            <Col xl={3} lg={4}>
                <h6>Parameters</h6>
                <Form.Group className="mb-3 sfy-field">
                    <Form.Label className="w-100">Page Code</Form.Label>
                    <Form.Control
                        type="text"
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                    />
                </Form.Group>
                <Form.Group className="mb-3 sfy-field">
                    <Form.Label className="w-100">Language</Form.Label>
                    <Form.Select
                        aria-label="Select language"
                        value={locale}
                        onChange={(e) => setLocale(e.target.value)}
                    >
                        <option value="">-- Select Language --</option>
                        {Object.keys(initData.languages.data).map((locale) => {
                            const lang: Language =
                                initData.languages.data[locale]

                            return (
                                <option key={locale} value={locale}>
                                    {lang.name}
                                </option>
                            )
                        })}
                    </Form.Select>
                </Form.Group>
            </Col>
            <Col xl={9} lg={8}>
                <ResultContainer result={result} />
            </Col>
        </Row>
    )
}

export default PageEndpoint
